export const HUBS = {
  MARKETING: 'MARKETING',
  SALES: 'SALES',
  SERVICE: 'SERVICE',
  CMS: 'CMS',
  OPS: 'OPS',
  COMMERCE: 'COMMERCE'
};
export const RELEVANCY_FACTORS = {
  HUBS: 'hubs',
  SUB_SUITES: 'subSuites',
  DATA_TYPES: 'dataTypes',
  DIMENSION_TYPES: 'dimensionTypes'
};
export const RELEVANCY_DATA_SOURCES = {
  LAST_PAGE: 'LAST_PAGE',
  HOME_PAGE: 'HOME_PAGE',
  BOOKMARKS: 'BOOKMARKS',
  SIGNUP_SURVEY: 'SIGNUP_SURVEY',
  ORIGIN_DASHBOARD: 'ORIGIN_DASHBOARD',
  DERIVED_PERSONAS: 'DERIVED_PERSONAS'
};